import tw from "tailwind-styled-components";
import {
    MdKeyboardArrowLeft,
    MdKeyboardArrowRight,
    MdClose,
} from "react-icons/md";
import { BoxHead, DownloadBtn, Underline } from "../../Styles/PageStyles";
import NotFoundModel from "../../NotFoundModel";
import { useState } from "react";
import SideModal from "../../SideModal";
import PropertyMediaUploadModal from "./PropertyMediaUploadModal";
import PropertyEditMediaModal from "./PropertyEditMediaModal";
import ShareModal from "./ShareLink";
import Config from "../../../Config";
import { useSelector } from "react-redux";

const InventoryImagesModal = ({
    images,
    currentImageIndex,
    setCurrentImageIndex,
    handleImageNavigation,
    setIsMediaAdd,
    isMediaAdd,
    propId,
    isMediaLoading,
    uploadMediaMutate,
    editMediaMutate,
    isEditMediaLoading,
    setIsMediaEdit,
    isMediaEdit,
    setSelectedData,
    selectedData,
    apiData
}) => {
    const [showShareModal, setShowShareModal] = useState(false);
    const user = useSelector((state) => state.UserReducer.user);
    const [isFullScreenModalOpen, setIsFullScreenModalOpen] =
        useState(false);
    const handleImageClick = (index) => {
        setCurrentImageIndex(index);
        setIsFullScreenModalOpen(true);
    };
    const remainingImagesCount = images.length - 4;

    return (
        <>
            <Wrapper>
                <BoxHead>
                    <TabTitle className="!mb-0 whitespace-nowrap">
                        Media
                        <Underline />
                    </TabTitle>
                    {user?.role !== Config.STAFF_ROLES.SALES_HEAD &&
                        <DownloadBtn type="button" onClick={() => setIsMediaAdd(true)}>
                            Add Media
                        </DownloadBtn>
                    }
                </BoxHead>
                {images.length > 0 ? (
                    <HeroSection>
                        <ImageGallery>
                            <MainImage onClick={() => handleImageClick(currentImageIndex)}>
                                <img
                                    src={images[currentImageIndex].imageUrl}
                                    alt={images[currentImageIndex].title}
                                    className="w-full h-full object-cover cursor-pointer"
                                />

                                <div className="absolute inset-0 flex items-start justify-end p-3 gap-2">
                                </div>

                                {/* NAV BUTTONS */}
                                <NavButton
                                    left
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleImageNavigation("prev");
                                    }}
                                >
                                    <MdKeyboardArrowLeft />
                                </NavButton>

                                <NavButton
                                    right
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleImageNavigation("next");
                                    }}
                                >
                                    <MdKeyboardArrowRight />
                                </NavButton>

                                {/* DOTS */}
                                <ImageIndicator>
                                    {images.map((_, idx) => (
                                        <Dot key={idx} active={idx === currentImageIndex} />
                                    ))}
                                </ImageIndicator>
                            </MainImage>
                        </ImageGallery>

                        <PropertyHeader>
                            <ThumbnailGrid>
                                {images.slice(0, 4).map((img, idx) => (
                                    <Thumbnail
                                        key={idx}
                                        active={idx === currentImageIndex}
                                        onClick={() => handleImageClick(idx)}
                                        className="group relative"
                                    >
                                        <div className="relative w-full h-full">
                                            <img
                                                src={img.imageUrl}
                                                alt={img.title}
                                                className="w-full h-full object-cover"
                                            />

                                            {idx === currentImageIndex && (
                                                <div className="absolute inset-0 border-2 border-primary-500 rounded-lg" />
                                            )}

                                            {idx === 3 && remainingImagesCount > 0 && (
                                                <div className="absolute inset-0 bg-black/60 flex items-center justify-center rounded-lg">
                                                    <span className="text-white font-semibold text-lg">
                                                        +{remainingImagesCount}
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    </Thumbnail>
                                ))}

                                {images.length < 4 && (
                                    <Thumbnail
                                        className="flex items-center justify-center border-2 border-dashed border-gray-300 cursor-pointer hover:bg-gray-100 transition"
                                        onClick={() => setIsMediaAdd(true)}
                                    >
                                        <span className="text-gray-500 font-medium">
                                            + Add Media
                                        </span>
                                    </Thumbnail>
                                )}
                            </ThumbnailGrid>
                        </PropertyHeader>
                    </HeroSection>
                ) : (
                    <NotFoundModel msg={"No media uploaded yet"} />
                )}
            </Wrapper>

            {/* Full Screen Modal */}
            {isFullScreenModalOpen && (
                <FullScreenModal>
                    <CloseButton onClick={() => setIsFullScreenModalOpen(false)}>
                        <MdClose size={24} />
                    </CloseButton>

                    <FullScreenContent>
                        <FullScreenImageContainer>
                            <img
                                src={images[currentImageIndex].imageUrl}
                                alt={images[currentImageIndex].title}
                                className="max-w-full max-h-[70vh] object-contain"
                            />

                            <FullScreenNavButton left onClick={() => handleImageNavigation("prev")}>
                                <MdKeyboardArrowLeft size={30} />
                            </FullScreenNavButton>

                            <FullScreenNavButton right onClick={() => handleImageNavigation("next")}>
                                <MdKeyboardArrowRight size={30} />
                            </FullScreenNavButton>
                            <FullScreenImageTitle>
                                <h3>{images[currentImageIndex].title}</h3>
                            </FullScreenImageTitle>
                        </FullScreenImageContainer>

                        <ThumbnailStrip>
                            {images.map((img, idx) => (
                                <StripThumbnail
                                    key={idx}
                                    active={idx === currentImageIndex}
                                    onClick={() => setCurrentImageIndex(idx)}
                                >
                                    <img src={img.imageUrl} alt={img.title} className="w-full h-full object-cover" />
                                </StripThumbnail>
                            ))}
                        </ThumbnailStrip>
                    </FullScreenContent>
                </FullScreenModal>
            )}
            <SideModal
                isOpen={isMediaAdd}
                onClose={() => setIsMediaAdd(false)}
            >
                <PropertyMediaUploadModal
                    handleClose={() => setIsMediaAdd(false)}
                    setIsMediaAdd={setIsMediaAdd}
                    uploadMediaMutate={uploadMediaMutate}
                    isMediaLoading={isMediaLoading}
                    propId={propId}
                />
            </SideModal>
            <SideModal
                isOpen={isMediaEdit}
                onClose={() => setIsMediaEdit(false)}
            >
                <PropertyEditMediaModal
                    handleClose={() => setIsMediaEdit(false)}
                    setIsMediaEdit={setIsMediaEdit}
                    uploadMediaMutate={editMediaMutate}
                    isMediaLoading={isEditMediaLoading}
                    propId={propId}
                    selectedData={selectedData}
                />
            </SideModal>
            <ShareModal
                isOpen={showShareModal}
                onClose={() => setShowShareModal(false)}
                shareData={{
                    link: `${Config.propertyShareUrl}/${apiData?.property?.gId}`
                }}
            />
        </>
    );
};

// STYLES
const HeroSection = tw.div`grid lg:grid-cols-5 gap-6 rounded-xl`;
const ImageGallery = tw.div`lg:col-span-3 space-y-4`;
const MainImage = tw.div`
  relative rounded-xl overflow-hidden
  flex items-center justify-center h-80 md:h-96
`;
const NavButton = tw.button`
  absolute top-1/2 transform -translate-y-1/2 
  w-8 h-8 bg-white/90 rounded-full 
  flex items-center justify-center text-xl font-bold 
  shadow-lg hover:bg-white transition-all z-10 
  ${({ left }) => (left ? "left-4" : "right-4")}
`;
const ImageIndicator = tw.div`
  absolute bottom-4 left-1/2 transform -translate-x-1/2 
  flex space-x-2 z-10
`;
const Dot = tw.div`
  w-2 h-2 rounded-full 
  ${({ active }) => (active ? "bg-primary-500" : "bg-gray-300")}
`;
const ThumbnailGrid = tw.div`grid grid-cols-2 gap-1`;
const Thumbnail = tw.div`
  relative h-20 md:h-48 rounded-lg overflow-hidden cursor-pointer 
  border ${({ active }) =>
        active ? "border-primary-color" : "border-transparent"} 
  hover:border-primary-color/80 transition-all
`;
const PropertyHeader = tw.div`lg:col-span-2 space-y-4`;
const TabTitle = tw.h2`
  text-lg text-black font-semibold space-x-2 items-center mb-5 rounded-md
`;
const Wrapper = tw.div`px-4 space-y-4 mt-2`;
const FullScreenModal = tw.div`
    fixed inset-0 z-50 bg-black/95 flex items-center justify-center
`;
const CloseButton = tw.button`
    absolute top-6 right-6 z-50 text-white hover:text-gray-300 
    transition-colors bg-black/20 rounded-full p-2
`;
const FullScreenContent = tw.div`
    w-full h-full flex flex-col items-center justify-center p-4 md:p-8
`;
const FullScreenImageContainer = tw.div`
    relative flex items-center justify-center mb-4 w-full
`;
const FullScreenNavButton = tw.button`
    absolute top-1/2 transform -translate-y-1/2 
    w-10 h-10 md:w-12 md:h-12 bg-white/20 hover:bg-white/30 
    rounded-full flex items-center justify-center 
    text-white transition-all z-10
    ${({ left }) => (left ? "left-2 md:left-4" : "right-2 md:right-4")}
`;
const ThumbnailStrip = tw.div`
    flex gap-2 overflow-x-auto pb-2 md:pb-4 px-4 max-w-full
    &::-webkit-scrollbar {
        height: 4px;
    }
    &::-webkit-scrollbar-track {
        background: #374151;
        border-radius: 2px;
    }
    &::-webkit-scrollbar-thumb {
        background: #6B7280;
        border-radius: 2px;
    }
`;
const StripThumbnail = tw.div`
    flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden cursor-pointer
    border-2 transition-all
    ${({ active }) => active ? "border-primary-500 opacity-100" : "border-transparent opacity-60 hover:opacity-100"}
`;
const FullScreenImageTitle = tw.div`
    absolute bottom-2 left-1/2 transform -translate-x-1/2
    text-white text-center z-20 rounded-md
    bg-black/50 px-4 py-1
    backdrop-blur-sm
    font-medium text-sm md:text-base
    truncate
`;

export default InventoryImagesModal;